<template>
    <div>
            <div class="heading-travel-policy">
                <span :class="internationalAirFareCapObj.isActive?'tag is-success':'tag'">Standard rule</span> 
                
                <div class="right-content">
                    <div class="lefttext">
                        <p class="paragrapgh">International airfare cap</p>
                        <p>Trigger for any flight between countries when the total cost is above
                        
                            <span class="rule-config-variable" @click="isEdit = !isEdit">
                                {{internationalAirFareCapObj.value ? '$'+internationalAirFareCapObj.value : 'N/A'}}

                                <b-icon icon="pencil" size="is-small" ></b-icon>                            
                            </span>
                        </p>
                    </div>
                    <div class="allbtns">
                        
                        <b-switch 
                            :rounded="true" 
                            :value="internationalAirFareCapObj.isActive" 
                            v-model="internationalAirFareCapObj.isActive"
                            @input="internationalAirfareCap" 
                            :left-label="true"
                            >{{ internationalAirFareCapObj.isActive ? 'Active' : 'Inactive' }}
                        </b-switch>
                    </div>
                </div>
            </div>
            <div v-if="isEdit" class="edittravelpolicy">
                <InternationalAirFareCap @internationalAirFareCap="getValue" :internationalAirFare="internationalAirFareCapObj.value"/>
                <p>Enter amount</p>
                <b-button @click="saveCall">SAVE</b-button>
            </div>
            </div>
</template>
<script>
import InternationalAirFareCap from '../CommonRules/InternationalAirFareCap.vue';
export default{
    name:"",
    props: {
    value: {
      type: [Object],
    },
  },
    components:{InternationalAirFareCap},

    data(){
        return{
            internationalAirFareCapObj:this.value?this.value:{
                    name: "internationalAirfareCap",
                    isActive: false,
                    value: 1500,
                    type:'air',
                    message:'',
          },
          isEdit:false,
          emitedValue : null
        }
    },
    methods:{
        saveCall(){
            this.isEdit = false;
            if(this.emitedValue || this.emitedValue=='') {
                this.internationalAirFareCapObj.value = this.emitedValue;
            }
        },
        getValue(val) {
          this.emitedValue = val;
        },
        internationalAirfareCap(){
            this.internationalAirFareCapObj.message=this.buildMessage;
            this.$emit('internationalAirfareCap',this.internationalAirFareCapObj)
        }
    },
    mounted(){
        this.internationalAirFareCapObj.type='air';
        this.internationalAirFareCapObj.message=this.buildMessage;

        this.$emit('internationalAirfareCap',this.internationalAirFareCapObj)
    },
    computed:{
        buildMessage(){

            var string ='Trigger for any flight between countries when the total cost is above';

            return string + (this.internationalAirFareCapObj.value ? ' $'+this.internationalAirFareCapObj.value : 'N/A');
        }
    },
    watch: {
    value: {
      handler(newVal, prevVal) {
        this.internationalAirFareCapObj = this.value;
        this.internationalAirFareCapObj.type='air';
        this.internationalAirFareCapObj.message=this.buildMessage;
        this.$emit('internationalAirfareCap',this.internationalAirFareCapObj)

      },
      deep: true,
    },
  },
}</script>